<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-fbaFlipOrderPurchase',
  components: { PageTable },
}
</script>
